import React, { Component } from 'react';
import { Link } from 'react-router';
import './ArtCard.css';

class ArtCard extends Component {

    render() {
        const { details } = this.props;
        return(
            <div className="work">
                <Link to={`/category/${details}`}>
                    <img src={`img/${details}.jpg`} className="media" alt={details}/>
                    <div className="caption">
                        <div className="work_title">
                            <h1>{ details }</h1>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }
}

export default ArtCard;




// WEBPACK FOOTER //
// ./src/components/ArtCard.js